import './Cards.scss';

import { ReactNode } from 'react';

interface CardsProps {
  background?: string;
  removeTopPadding?: boolean;
  removeBottomPadding?: boolean;
  sectionHeader?: ReactNode;
  sectionFooter?: ReactNode;
  children: ReactNode;
}

const Cards = ({
  background = '',
  removeTopPadding = false,
  removeBottomPadding = false,
  sectionHeader,
  sectionFooter,
  children,
}: CardsProps) => {
  const classNames = ['cards-section', background, removeTopPadding ? 'pt-0' : '', removeBottomPadding ? 'pb-0' : '']
    .filter(Boolean)
    .join(' ');

  return (
    <section className={classNames}>
      <div className='container cards'>
        {sectionHeader && <div className='cards-section-title text-left'>{sectionHeader}</div>}
        <div className='row g-4 cards-wrapper'>{children}</div>
        {sectionFooter && <div className='cards-section-footer text-left'>{sectionFooter}</div>}
      </div>
    </section>
  );
};

export default Cards;
